import React, { useEffect, useState, useRef, useContext } from 'react';
import 'antd/dist/antd.min.css';
import { Collapse, Modal } from 'antd';

import button_arrow_left from 'images/button_arrow_left.svg';
import icon_questioner_big from 'images/newIconTopopUp/icon_questioner_big.svg';
import img_for_test from 'images/newIconTopopUp/img_for_test.svg';
import icon_left_arrow_in_circle from 'images/newIconTopopUp/icon_left_arrow_in_circle.svg';
import icon_right_arrow_in_circle from 'images/newIconTopopUp/icon_right_arrow_in_circle.svg';

import icon_arrow_right_white from 'images/icon_arrow_right_white.svg';
import icon_arrow_down_light from 'images/icon_arrow_down_light.svg';

import icon_new_left_carousel from 'images/menu/icon_new_left_carousel.svg';
import icon_new_right_carousel from 'images/menu/icon_new_right_carousel.svg';

import analysis_icon from 'images/help/analysis_icon.svg';
import dashbord_icon from 'images/help/dashbord_icon.svg';
import transform_icon from 'images/help/transform_icon.svg';

import sortBy from 'lodash/sortBy';

import { AppContext } from 'context/AppContext';

import {
    getHelpItem,
    createHelpItem,
    deleteHelpItem,
    getHelpContent,
    getHelpContentToNav,
    getGlossaryTerm
} from 'services/help.js';

import { changeDefaults } from 'services/login';


import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import SupportUs from 'components/SupportUs';

const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

const itemsToCarousel = [
    <div className="item" data-value="1">
        1
    </div>,
    <div className="item" data-value="2">
        2
    </div>,
    <div className="item" data-value="3">
        3
    </div>,
    <div className="item" data-value="4">
        4
    </div>,
    <div className="item" data-value="5">
        5
    </div>
];

const HelpMenu = () => {
    let appContext = useContext(AppContext);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleGlossary, setIsModalVisibleGlossary] = useState(false);
    const [menuStrcture, setMenuStrcture] = useState(null);
    const [filterContentArray, setFilterContentArray] = useState(null);
    const [filteredArray, setFilteredArray] = useState(null);

    const [glossaryData, setGlossaryData] = useState([]);

    // const [activeIndex, setActiveIndex] = useState(0);
    // const [isActiveIndex, setIsActiveIndex] = useState('__active');

    const takeInfoAboutCarouse = (Index, isActive) => {
        // setActiveIndex(activeIndex);
        // setIsActiveIndex(isActive);
        // console.log(`first`, Index);
        // console.log(`isActive`, isActive);
    };

    const relunchOnboarding = async ()=>{
        let send1 = await changeDefaults(Number(sessionStorage.getItem('onboarding_home')),{name:'onboarding_home', value:'true'});
        let send2 = await changeDefaults(Number(sessionStorage.getItem('onboarding_project')),{name:'onboarding_project', value:'true'});
            return send1, send2, window.location.reload(true);
    }

    // Carousel
    const percent = 0.2;
    const sectionn = useRef(null);
    const [padding, setPadding] = useState(0);

    const syncState = () => {
        const { current } = sectionn;
        if (current) {
            setPadding(current.offsetWidth * percent);
        }
    };

    useEffect(syncState, []);
    // Carousel End

    // check size
    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };

    const [windowSize, setWindowSize] = useState(getWindowSize());
    // check size end

    // let widthModal = windowSize.innerWidth > 1000 ? '800px' : '680px';

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModalGlossary = () => {
        setIsModalVisibleGlossary(true);
    };

    const handleOkGlossary = () => {
        setIsModalVisibleGlossary(false);
    };

    const handleCancelGlossary = () => {
        setIsModalVisibleGlossary(false);
    };

    useEffect(() => {
        getHelpItem().then((res) => {
            setMenuStrcture(res.data);
        });

        getGlossaryTerm().then((res) => {
            setGlossaryData(res.data.sort(function(a,b) {
                return a.term.localeCompare(b.term);
            }));

        });

        getHelpContentToNav().then((res) => {
            // console.log(`getHelpContentToNav`, res);
            setFilterContentArray(res.data);
        });
    }, []);

    const filterArray = (id) => {
        let filteredArray = filterContentArray.filter(
            (x) => x.help_item === id
        );

        let sorterLodash = sortBy(filteredArray, ['order']);
        setFilteredArray(sorterLodash);
    };

    // console.log(`filtered array: `, filteredArray);

    let section = [];

    let topics = [];
    let newMenuStructuresection = [];
    let newMenuStructureTopic = [];

    if (menuStrcture !== null) {
        // console.log(`menuStrcture`, menuStrcture);

        // section = menuStrcture.map((item) => {
        //     console.log(`item`, item.topics.name);
        //     for (let i in item.topics.name) {
        //         let itemss = item.topics.name[i];
        //         console.log(`itemss`, itemss);
        //     }

        //     return (
        //         <Panel header={item.name} key={item.id}>
        //             <ul>
        //                 <li
        //                     onClick={() => {
        //                         showModal();
        //                     }}
        //                 >
        //                     {item.topics.name}
        //                 </li>
        //             </ul>
        //         </Panel>
        //     );

        let menuIcons = {'Dashboard': dashbord_icon, 'Analysis':analysis_icon,'Transform':transform_icon};


        for (let i = 0; i < menuStrcture.length; i++) {
            // topics = menuStrcture[i].topics[j].name;
            // section.push(menuStrcture[i].name);
            // console.log(`section: `, menuStrcture[i]);

            for (let j = 0; j < menuStrcture[i].topics.length; j++) {
                newMenuStructureTopic.push(
                    <li
                        key={menuStrcture[i].id + menuStrcture[i].name}
                        onClick={() => {
                            showModal();
                            // console.log(
                            //     `menuStrcture[i]: `,
                            //     menuStrcture[i].topics[j].id
                            // );
                            filterArray(menuStrcture[i].topics[j].id);
                        }}
                    >
                        {menuStrcture[i].topics[j].name}
                    </li>
                );
            }

            let panelHeader = (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div>{menuStrcture[i].name}</div>{' '}
                        <div style={{ position: 'absolute', right: '0px' }}>
                            {/* {menuIcons.hasOwnProperty(menuStrcture[i].name) ? <img src={menuIcons[menuStrcture[i].name]} /> : null} */}
                            {menuStrcture[i].name in menuIcons ? <img src={menuIcons[menuStrcture[i].name]} /> : null}
                        </div>
                    </div>
                </>
            );

            newMenuStructuresection.push(
                <Panel header={panelHeader} key={menuStrcture[i].id}>
                    {/* <Panel header={menuStrcture[i].name} key={menuStrcture[i].id}> */}
                    <ul>{newMenuStructureTopic}</ul>
                </Panel>
            );

            newMenuStructureTopic = [];
        }

        // console.log(`section`, section);
        // console.log(`topics`, topics);

        // for (let j = 0; j < menuStrcture[i].topics.length; i++) {
        //     // topics = menuStrcture[i].topics[j].name;
        //     // console.log(`topics name:`, topics);
        //     console.log(`section number: ${i}, topics nuber: ${j}`);
        // }

        // for (let i in menuStrcture) {
        //     section = menuStrcture[i].name;
        //     console.log(`menuStrcture for`, section);

        // console.log(
        //     `menuStrcture[i].topics.name`,
        //     menuStrcture[i].topics.length
        // );

        // for (let j = 0; j < menuStrcture[i].topics.length; i++) {
        //     // topics = menuStrcture[i].topics[j].name;
        //     // console.log(`topics name:`, topics);
        //     console.log(`section number: ${i}, topics nuber: ${j}`);
        // }

        // console.log(`topics after for`, topics);

        // let addSection = (
        //     <Panel header={menuStrcture[i].name} key={menuStrcture[i].id}>
        //         <ul>
        //             <li
        //                 onClick={() => {
        //                     showModal();
        //                 }}
        //             >
        //                 Uploading Data
        //             </li>
        //             <li>Uploading Data (advanced)</li>
        //             <li>Sampling</li>
        //         </ul>
        //     </Panel>
        // );

        // section.push(addSection);
        // }
    }
    let filtredArrayMap;
    let arrayWithModal = [];

    // console.log(`item`, filteredArray);

    if (filteredArray !== null) {
        filtredArrayMap = filteredArray.map((item, index) => {
            // arrayWithModal.push()
            return (
                <div
                // style={{ margin: '0px 35px' }}
                >
                    <div
                        className="container-title"
                        style={{ marginTop: '24px' }}
                    >
                        <div className="title">Help: {item.title}</div>
                    </div>
                    <div className="container-img">
                        <div className="card-img">
                            <img src={item.image} />
                        </div>
                        <div className="card-step">
                            Step {index + 1} of {filteredArray.length}
                        </div>
                    </div>
                    <div
                        className="container-footer"
                        style={
                            {
                                // marginRight: '0px',
                                // boxShadow: 'inset 0 0 0em gold, 0 9em 1em 10em #fff',
                                // position: 'absolute',
                                // zIndex: 10000
                            }
                        }
                    >
                        <div className="left" style={{ width: '8px' }}>
                            {/* <img
                                onClick={(e) => {
                                    slidePrev(index);
                                }}
                                src={icon_left_arrow_in_circle}
                            /> */}
                        </div>
                        <div className="center">{item.description}</div>
                        <div className="right">
                            {/* <img
                                onClick={(e) => {
                                    slideNext(index + 2);
                                }}
                                src={icon_right_arrow_in_circle}
                            /> */}
                        </div>
                    </div>
                </div>
            );
        });
    }

    let glossaryDataMap = glossaryData.map((item) => {
        return (
            <>
                <tr>
                    <td><p>{item.term}</p></td>
                    {/* <td>{item.description}</td> */}
                    <td><p dangerouslySetInnerHTML={{__html: item.description}} ></p></td>
                </tr>
            </>
        );
    });

    

    //     <div ref={section}>
    //     <AliceCarousel
    //         infinite
    //         mouseTracking
    //         items={itemsToCarousel}
    //         paddingRight={padding}
    //         onResized={syncState}
    //     />
    // </div>

    // if (filteredArray !== null) {
    //     filtredArrayMap = filteredArray.map((item) => {
    //         // arrayWithModal.push()
    //         return (
    //             <div>
    //                 <div className="modal-help-container">
    //                     <img
    //                         className="new-icon-to-pop-up"
    //                         src={icon_questioner_big}
    //                     />
    //                     <div className="container-title">
    //                         <div className="title">Help: {item.title}</div>
    //                     </div>
    //                     <div className="container-img">
    //                         <div className="card-img">
    //                             <img src={item.image} />
    //                         </div>
    //                         <div className="card-step">Step 1 of 3</div>
    //                     </div>
    //                     <div className="container-footer">
    //                         <div className="left">
    //                             <img src={icon_left_arrow_in_circle} />
    //                         </div>
    //                         <div className="center">{item.description}</div>
    //                         <div className="right">
    //                             <img src={icon_right_arrow_in_circle} />
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>
    //         );
    //     });
    // }

    const responsive = {
        0: { items: 1 }
        // 568: { items: 2 }
        // 1024: { items: 3 }
    };

    let isActive = true;

    // const [activeIndex, setActiveIndex] = useState(null);
    // const [isActiveIndex, setIsActiveIndex] = useState(null);

    // let activeIndex;
    // let isActiveIndex;

    let shadeIn = {
        width: 270,
        height: '100%',
        backgroundColor: '#407cb1',
        transition: 'width 5s',
        padding: '10px 0px 20px 20px',
        color: 'white',
        position: 'fixed',
        top: 0,
        zIndex: 1000,
        boxShadow: '2800px 0px 0px 2800px rgb(50 50 50 / 60%)'
    };
    let shadeOut = {
        width: 270,
        height: '100%',
        backgroundColor: '#407cb1',
        transition: 'width 5s',
        padding: '10px 20px 20px 20px',
        color: 'white',
        position: 'fixed',
        top: 0,
        zIndex: 1000
    };

    return (
        <>
            <div className="help-menu-container-padd">
                <div
                    id="univariate-container"
                    style={appContext.helpNavIsVisible ? shadeIn : shadeOut}
                >
                    <img
                        alt=""
                        className="button-arrow-left-nav"
                        onClick={() => {
                            appContext.setHelpNavIsVisible(false);
                        }}
                        src={button_arrow_left}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '-16px'
                        }}
                    />

                    <div className="help-container">
                        <div>
                            <div className="container-title">Help</div>
                            <div className="collapse-container">
                                <Collapse
                                    bordered={false}
                                    defaultActiveKey={['1']}
                                    ghost
                                    expandIcon={() => {
                                        return isActive ? (
                                            <img
                                                src={icon_arrow_right_white}
                                                alt=""
                                            />
                                        ) : (
                                            <img
                                                src={icon_arrow_down_light}
                                                alt=""
                                            />
                                        );
                                    }}
                                >
                                    {newMenuStructuresection}
                                </Collapse>
                            </div>

                            <div
                                className="container-title"
                                onClick={() => {
                                    showModalGlossary();
                                }}
                                style={{ cursor: 'pointer', borderBottom: '2px solid #d9d9d9',paddingBottom: '14px' }}
                            >
                                Glossary
                            </div>
                            {/* <div
                                className="container-title"
                                // onClick={() => {
                                //     showModalGlossary();
                                // }}
                                style={{ borderBottom: '2px solid #d9d9d9'}}
                            >
                                Toolbar Icons and Views
                            </div> */}
                            <div
                                className="container-title"
                                onClick={()=>{ relunchOnboarding()}}
                                style={{cursor: 'pointer'}}
                            >
                                Views
                            </div>


                        </div>
                        {/* <div className='container-footer'>
                            <p style={{ marginBottom: '0px'}}>For support, contact us at:</p>
                            <a style={{color: '#fff'}} href="mailto:support@econometrica.com">support@econometrica.com</a>
                        </div> */}
                        <SupportUs />
                    </div>
                </div>
                <Modal
                    width={690}
                    closable={false}
                    footer={null}
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    className="help-menu-container-padd"
                >
                    <div className="modal-help-container">
                        <img
                            className="new-icon-to-pop-up"
                            src={icon_questioner_big}
                        />
                        <div
                        //  ref={section}
                        >
                            <AliceCarousel
                                // infinite
                                // mouseTracking={true}
                                // onResized={syncState}
                                // paddingRight={padding}
                                // activeIndex={2}
                                items={filtredArrayMap}
                                controlsStrategy="default"
                                paddingLeft={46}
                                paddingRight={70}
                                // responsive={responsive}
                                renderDotsItem={(e) => {}}
                                renderPrevButton={(e) => {
                                    let isDisabled = e.isDisabled;
                                    return (
                                        <>
                                            {!isDisabled ? (
                                                <img
                                                    style={{
                                                        position: 'absolute',
                                                        left: '0px',
                                                        top: 566,
                                                        transform:
                                                            'rotate(0.5turn)',
                                                        backgroundColor:
                                                            'white',
                                                        cursor: 'pointer'
                                                    }}
                                                    // src={icon_new_left_carousel}
                                                    src={
                                                        icon_new_right_carousel
                                                    }
                                                    alt=""
                                                />
                                            ) : null}
                                        </>
                                    );
                                }}
                                renderNextButton={(e) => {
                                    let isDisabled = e.isDisabled;
                                    return (
                                        <>
                                            {!isDisabled ? (
                                                <img
                                                    style={{
                                                        position: 'absolute',
                                                        right: '0px',
                                                        top: 566,
                                                        backgroundColor:
                                                            'white',
                                                        cursor: 'pointer'
                                                    }}
                                                    src={
                                                        icon_new_right_carousel
                                                    }
                                                    alt=""
                                                />
                                            ) : null}
                                        </>
                                    );
                                }}
                            />
                        </div>
                    </div>
                    {/* {filtredArrayMap} */}
                </Modal>
                {/* <Modal
                width={800}
                closable={false}
                footer={null}
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="modal-help-container">
                    <img
                        className="new-icon-to-pop-up"
                        src={icon_questioner_big}
                    />
                    <div className="container-title">
                        <div className="title">Help: Uploading Data</div>
                    </div>
                    <div className="container-img">
                        <div className="card-img">
                            <img src={img_for_test} />
                        </div>
                        <div className="card-step">Step 1 of 3</div>
                    </div>
                    <div className="container-footer">
                        <div className="left">
                            <img src={icon_left_arrow_in_circle} />
                        </div>
                        <div className="center">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Vitae tristique vestibulum sit commodo. In mi
                            nisl risus tortor volutpat nunc. Nullam facilisis
                            sit sodales vivamus quis. Lorem ipsum dolor sit
                            amet, consectetur adipiscing elit. Vitae tristique
                            vestibulum sit commodo.
                        </div>
                        <div className="right">
                            <img src={icon_right_arrow_in_circle} />
                        </div>
                    </div>
                </div>
            </Modal> */}
            </div>

            <Modal
                width={690}
                closable={false}
                footer={null}
                visible={isModalVisibleGlossary}
                onOk={handleOkGlossary}
                onCancel={handleCancelGlossary}
                className="help-menu-container-padd"
            >
                <div className="modal-help-container">
                    <img
                        className="new-icon-to-pop-up"
                        src={icon_questioner_big}
                    />
                    <div className="container-glossary" style={{ height: 730 }}>
                        <div className="title">Help: Glossary</div>
                        <div className="container-glossary-content">
                            <table className="table-glossary">
                                <tbody>
                                    <tr>
                                        <td className="title">
                                            Term
                                        </td>
                                        <td className="title">Definition</td>
                                    </tr>
                                    {/* <tr>
                                        <td>
                                            Autoregression / AutoregressionX
                                        </td>
                                        <td>
                                            Univariate Autoregression function
                                            as well as Multivariate ARX estimate
                                            their models using Conditional
                                            Maximum Likelihood (OLS)
                                            Econometrica uses Python library
                                            called “statsmodels” and its
                                            function “AutoReg()” documented in
                                            the link below:
                                            https://www.statsmodels.org/stable/generated/statsmodels.tsa.ar_model.AutoReg.html?highlight=autoreg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Confidence Intervals - Notches</td>
                                        <td>
                                            Notches show the 95% confidence
                                            interval (CI) for the median. They
                                            are calculated using following
                                            formula: median ± 1.58 × IQR/√n
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Histogram</td>
                                        <td>
                                            Notches show the 95% confidence
                                            interval (CI) for the median. They
                                            are calculated using following
                                            formula: median ± 1.58 × IQR/√n
                                        </td>
                                    </tr> */}
                                    {glossaryDataMap}
                                </tbody>
                            </table>

                            {/* <table>
                                <tbody>{glossaryDataMap}</tbody>
                            </table> */}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default HelpMenu;
